import { Box, Select, Portal, Spinner, createListCollection } from "@chakra-ui/react";

function DropdownSelect({
  label,
  collection,
  value,
  onValueChange,
  isLoading,
  placeholder,
}: {
  label: string;
  collection: { label: string; value: string }[];
  value?: string;
  onValueChange: (value: string) => void;
  isLoading: boolean;
  placeholder: string;
}) {

  return (
    <Box>
      <Select.Root
        collection={createListCollection({ items: collection })}
        value={value ? [value] : undefined}
        onValueChange={(e) => onValueChange(e.value[0])}
        size="sm"
        disabled={isLoading}
      >
        <Select.HiddenSelect />
        <Select.Label>{label}</Select.Label>
        <Select.Control>
          <Select.Trigger>
            <Select.ValueText placeholder={placeholder} />
          </Select.Trigger>
          <Select.IndicatorGroup>
            <Select.Indicator />
          </Select.IndicatorGroup>
        </Select.Control>
        <Portal>
          <Select.Positioner>
            <Select.Content>
              {collection.map((item) => (
                <Select.Item item={item} key={item.value}>
                  {item.label}
                  <Select.ItemIndicator />
                </Select.Item>
              ))}
            </Select.Content>
          </Select.Positioner>
        </Portal>
      </Select.Root>
      {isLoading && <Spinner />}
    </Box>
  );
}

export default DropdownSelect;
